// src/components/LeftPanel.js
import React, { Component } from 'react';
import Icon from './Icon';



const STATS = [
  { value: '1,200+', label: 'Daily Patients' },
  { value: '48',     label: 'Doctors'         },
  { value: '99.5%',  label: 'Uptime'          },
];

class LeftPanel extends Component {
  render() {
    return (
      <div className="auth-left">

        {/* Animated blobs */}
        <div
          className="auth-left-blob"
          style={{
            width: 400, height: 400,
            top: -110, right: -110,
            background: 'rgba(26,86,255,.13)',
            animationDuration: '14s',
          }}
        />
        <div
          className="auth-left-blob"
          style={{
            width: 260, height: 260,
            bottom: 50, left: -70,
            background: 'rgba(0,201,167,.09)',
            animationDuration: '10s',
            animationDelay: '-4s',
          }}
        />
        <div
          className="auth-left-blob"
          style={{
            width: 160, height: 160,
            top: '44%', right: 20,
            background: 'rgba(255,255,255,.045)',
            animationDuration: '8s',
            animationDelay: '-2s',
          }}
        />

        {/* Grid overlay */}
        <div className="auth-left-grid" />

        {/* Logo */}
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <Icon name="heartbeat" size={20} color="#fff" />
          </div>
          <div>
            <div className="auth-logo-name">DG Doctor</div>
            <div className="auth-logo-sub">Hospital Management</div>
          </div>
        </div>

        {/* Main content */}
        <div className="auth-left-content">

          <div className="auth-left-eyebrow">Smart Hospital Platform</div>

          <h1 className="auth-left-headline">
            Healthcare<br />
            <em>reimagined</em><br />
            for everyone.
          </h1>

          <p className="auth-left-desc">
            From booking to prescription to pharmacy — one seamless
            Smart QR journey for patients, doctors & staff.
          </p>

        

   

        </div>
      </div>
    );
  }
}

export default LeftPanel;
